import { applySort } from './sort-actions.js';
import { sortReducer as commerceSort } from './sort-slice.js';
/**
 * Loads the commerce sort reducer and returns the available sort action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the sort action creators.
 *
 * @group Actions
 * @category Sort
 */
export function loadSortActions(engine) {
    engine.addReducers({ commerceSort });
    return {
        applySort,
    };
}
